import * as ACTION from './constants';
import * as saga from './saga';
import {takeLatest} from 'redux-saga/effects';

export default function*() {
    yield takeLatest(ACTION.CLEAR_SCAN_BARCODE_HISTORY.REQUEST, saga.clearHistoryScanBarcode);
}